import { faqArticles } from '@/mocks/articles';

export default function FAQSection() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqArticles.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="w-full py-14 md:py-16 px-4 md:px-6 bg-background-100">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600">
            关于爱液下载平台，您可能想了解的问题
          </p>
        </div>

        <div className="space-y-3">
          {faqArticles.map((faq, index) => (
            <details key={index} className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
              <summary className="flex items-center justify-between p-5 cursor-pointer hover:bg-background-100 transition-colors list-none">
                <h4 className="text-sm font-semibold text-foreground-900 pr-8">
                  {faq.question}
                </h4>
                <i className="ri-add-line text-foreground-400 group-open:hidden text-sm flex-shrink-0"></i>
                <i className="ri-subtract-line text-primary-500 hidden group-open:block text-sm flex-shrink-0"></i>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}